<template>
    <div class="form-white-bg">
        <b-container fluid class="p-0">
            <b-row class="py-0">
                <b-col>
                    <div>
                        <MasterEmpty :createline="false" v-if="items.length === 0 && !loading" eheader="documentation"
                            econtent="documentation" eimg="/src/assets/Img/icons/master.svg" />
                        <Tableview v-if="items.length != 0" :value="items" :paginator="true"
                            class="p-datatable-gridlines" :rows="10" :rowHover="true" filterDisplay="menu"
                            :loading="loading1" responsiveLayout="scroll" :columns="headers"
                            :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                            @row-click="RowClick">
                            <template v-slot:Add>
                            </template>
                            <template v-slot:FileNameopen="{ data }">
                                <p> {{
                                    data.Name }}</p>
                            </template>
                            <template v-slot:ViewSlot="{ data }">
                                <div class="action-container">
                                    <button class="initiate-button" @click="fileviewer(data.QuotationFileName)">
                                        <i style="margin-right: 6px"></i>
                                        View
                                    </button>
                                </div>
                            </template>
                            <template v-slot:Status="{ data }">
                                <Badge v-if="data.IsActive == '0'" severity="warning">{{
                                    "InActive"
                                    }}</Badge>
                                <Badge v-if="data.IsActive == '1'" severity="success">{{
                                    "Active"
                                    }}</Badge>
                            </template>

                            <template v-slot:action="{ data }">
                                <span>
                                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                        @click="toggle($event, data)" />
                                    <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
                                </span>
                            </template>
                        </Tableview>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <div class="center" v-if="loading">
            <Loader :loading="loading" />
        </div>
    </div>
    <Mapping :content="ContentName" :visible="MappingPopup" @ok="closemapping()" />
    <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
    <ActivatedSuccessfully :visible="popup.activatepop" @ok="closetrigger()" />
    <InActivatedSuccessfully :visible="popup.inactivepop" @ok="closetrigger()" />
    <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="content" @yes="IsDelete(dataEdit)"
        @no="Deletemodel = false" />
    <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
        :content="$t('confirmation.editcontent')" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, h, computed, watch } from "vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import Tableview from '../../../../components/FormComponents/Table.vue';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../components/FormComponents/DeletedSuccessfully.vue";
import MasterEmpty from "../../../../components/Masters/MasterEmpty.vue";
import Mapping from "../../../../components/FormComponents/Mapping.vue";
import Loader from "../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../components/FormComponents/InActivateSuccessfully.vue";
import WithoutStockAffectService from '../../../../modules/Inventory/Service/WithoutStockAffectService';
import { useI18n } from 'vue-i18n';
import Button from "primevue/button";

export default defineComponent({
    components: {
        DeletedSuccessfully,
        EditConfirmation,
        DeleteConfirmationVue,
        Tableview,
        MasterEmpty,
        Loader,
        Mapping,
        ActivatedSuccessfully,
        InActivatedSuccessfully,

    },
    props: {
        IsAddButton: {
            type: Boolean,
            default: true
        }
    },
    setup() {
        onMounted(() => {
            isShow();
        });
        const router = useRouter();
        const route = useRoute();

        const Editmodel = ref(false);
        const { t } = useI18n();

        //Loading
        let loading = ref(false);
        let loading1 = ref(false);
        const ObjData = ref();
        const popup = ref({
            activatepop: false,
            inactivepop: false,
        });
        let content = ref("");

        let getId = 0;
        let Id = route.query.Id;
        let storebranchmapid = route.query.storebranchmapid;
        let BranchId = route.query.BranchId;


        const deletepop = ref(false);
        const Deletemodel = ref(false);
        watch(
            () => route.query.Id,
            (newVal: any) => {
                debugger;
                // alert('s')
                Id = route.query.Id
                if (Id != undefined) {
                    isShow()
                }
            }
        );
        function Editdata(data) {
            debugger;
            // alert(JSON.stringify(data))
            getId = data.Id;
            Editmodel.value = true;
        }
        function Deletedata(data, status) {
            getId = data.Id;
            dataEdit.value = data;
            Deletemodel.value = true;
            data.ActiveStatus = status;
            if (status == 1) {
                content.value = "Activate";
            } else if (status == 2) {
                content.value = "InActivate";
            } else {
                content.value = t('confirmation.deletecontent');
            }
        }
        const items = ref([
        ])
        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            FileName: { value: null, matchMode: FilterMatchMode.IN, options: items },
            FileSize: { value: null, matchMode: FilterMatchMode.IN, options: items },

            Type: { value: null, matchMode: FilterMatchMode.IN, options: items },
            FileType: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
            ActiveStatus: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
        };

        //DataTable Fields
        const headers = [
            {
                header: 'S.No',
                field: "Rownumber",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "boldclass",
            },
            {
                header: t('storetabdetails.documentationtableview.ModuleName'),
                field: "DocName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "boldclass",
            },
            {
                header: t('storetabdetails.documentationtableview.Code'),
                field: "DocNo",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "boldclass",
            },

            {
                header: t('storetabdetails.documentationtableview.Documentname'),
                field: "FileName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                slot: "FileNameopen",
                fieldDisplay: "false",
                sortable: false,

            },
            {
                header: t('storetabdetails.documentationtableview.UploadDate'),
                field: "CreatedAt",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "boldclass",
            },

            {
                header: "View",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                slot: "ViewSlot",
                fieldDisplay: "false",
                sortable: false,
            },
        ];


        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });
        const globalFilterFields = ref(headers.map((col) => col.field));

        const menu = ref();
        let InActivevisible = ref(false);
        let Activevisible = ref(false);
        let Editvisible = ref(false);

        const toggle = (event, data) => {
            debugger;
            ObjData.value = data;
            if (data.IsActive == 1) {
                InActivevisible.value = true
                Activevisible.value = false
            }
            else {
                InActivevisible.value = false
                Activevisible.value = true
            }

            menu.value.toggle(event);
        };

        const itemListed = ref([
            {
                items: [
                    {
                        label: "Edit",
                        icon: "editicon pi pi-pencil",
                        visible: InActivevisible,
                        command: async () => {
                            Editdata(ObjData.value);
                        },
                    },
                    {
                        label: "Delete",
                        icon: "deleteicon pi pi-trash",
                        visible: true,
                        command: async () => {
                            Deletedata(ObjData.value, 0);
                        },
                    },

                    {
                        label: "Active",
                        icon: "editicon pi pi-check-circle",
                        visible: Activevisible,
                        command: async () => {
                            Deletedata(ObjData.value, 1);
                        },
                    },
                    {
                        label: "InActive",
                        icon: "deleteicon pi pi-minus-circle",
                        visible: InActivevisible,
                        command: async () => {
                            Deletedata(ObjData.value, 2);
                        },
                    },
                ],
            },
        ]);

        //IsEdit Route
        function IsEdit() {
            router.push({
                path: "/consultationCreation",
                query: {
                    Id: getId,
                },
            });
        }

        const dataEdit = ref();
        const rowFocus = ref(false);

        // row click for table
        function RowClick(event: any) {
            debugger;
            rowFocus.value = true;

            // Editmodel.value = true;
            getId = event.data.Id;
        }

        //DataTable Array

        const isShow = async () => {
            try {
                debugger;
                loading.value = true;
                const response = await WithoutStockAffectService.FileListByStoreId(Id, BranchId);
                console.log(response.data);
                let count = 1
                response["result"] = response["result"]
                debugger
                items.value = response["result"].map((item, index) => {
                    item.Rownumber = index + 1;
                    item.Name = item.QuotationFileName.split('/').pop();
                    return item;
                });
                loading.value = false;
                debugger;
            } catch (error) {
                alert(error);
            }
        };
        let MappingPopup = ref(false);
        let ContentName = ref("");
        async function IsDelete(data) {
        }

        const edit = (data) => {
            router.push({
                path: "/documentation",
                query: {
                    Id: data.Id,
                },
            });
        };
        const IsCreate = () => {
            let CarePathWayDetail: any = ref({
                storebranchmapid: 0,
                Id: 0,
                laneMappingTemplateId: 0,
                carePathwayTemplateId: 0,
            })
            CarePathWayDetail.value.storebranchmapid = storebranchmapid
            CarePathWayDetail.value.Id = Id
            localStorage.setItem("CarePathWayDetails", JSON.stringify(CarePathWayDetail.value));



            router.push({
                path: "/documentation",
                name: "documentation",
                query: {
                    Type: "6",
                    Status: "0",
                },
            });


        };
        // Popup-Close
        function closemapping() {
            MappingPopup.value = false;
        }
        onMounted(() => {
            debugger;
            document.addEventListener("keydown", onKeyUp);
        });

        function onKeyUp(event: any) {
            debugger;

            console.log(dataEdit.value);
            if (
                (event.key == "e" ||
                    (Editmodel.value == false && event.key == "Enter")) &&
                rowFocus.value == true &&
                Deletemodel.value == false
            ) {
                Editmodel.value = true;
            } else if (
                event.altKey &&
                event.key == "n" &&
                Editmodel.value == false &&
                Deletemodel.value == false
            ) {
                IsCreate();
            } else if (
                (event.key == "y" || event.key == "Enter") &&
                Deletemodel.value == true &&
                Editmodel.value == false &&
                rowFocus.value == true
            ) {
                IsDelete(dataEdit.value);
            } else if (
                (event.key == "y" || event.key == "Enter") &&
                Editmodel.value == true &&
                rowFocus.value == true
            ) {
                IsEdit();
            } else if (
                event.key == "n" &&
                rowFocus.value == true &&
                Editmodel.value == true
            ) {
                Editmodel.value = false;
            } else if (
                event.key == "d" &&
                rowFocus.value == true &&
                Editmodel.value == false
            ) {
                Deletemodel.value = true;
                Editmodel.value = false;
            } else if (
                event.key == "n" &&
                rowFocus.value == true &&
                Deletemodel.value == true
            ) {
                Deletemodel.value = false;
            } else if (event.key == "Escape" && deletepop.value == true) {
                deletepop.value = false;
            } else if (event.key == "Enter" && rowFocus.value == false) {
                Editmodel.value = false;
            }
        }

        function closetrigger() {
            debugger;
            deletepop.value = false;
            popup.value.activatepop = false;
            popup.value.inactivepop = false;
        }
        function fileviewer(data) {
            const newTabUrl = data;
            window.open(newTabUrl, '_blank');
        }
        return {
            fileviewer,
            closemapping,
            ContentName,
            MappingPopup,
            Deletedata,
            Deletemodel,
            deletepop,
            Editmodel,
            Editdata,
            IsCreate,
            isShow,
            loading,
            IsDelete,
            headers,
            items,
            IsEdit,
            filters,
            globalFilterFields,
            filteredColumns,
            edit,
            RowClick,
            loading1,
            closetrigger,
            dataEdit,
            menu,
            toggle,
            itemListed,
            popup,
            content,
        };
    },
});
</script>

<style lang="scss" scoped>
@import "../../../../assets/variables.scss";

.filenamehighlight {
    margin: 10px;
    font-size: 14px;
    cursor: pointer;
    text-decoration: underline;
    color: rgba(5, 126, 225, 0.956);
}

.initiate-button {
    background-color: #0764a3;
    /* Blue */
    color: white;
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.initiate-button:hover {
    background-color: #0764a3;
    /* Darker Blue */
}

.initiate-button i {
    font-size: 16px;
}
</style>
